module.exports = __webpack_public_path__ + "static/media/eco-ecology-mountain-svgrepo-com.058ace4b.svg";